export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9834.9f3a7c98.jpg";